module.exports = __webpack_public_path__ + "static/media/kenvector_future.7310b00c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/kenvector_future.ttf
// module id = 1639
// module chunks = 0